export default "/external-link.45f9ebced57201df99625e6bb896ccc5.svg";